import { render, staticRenderFns } from "./SmsRejectIframe.vue?vue&type=template&id=83cac8e2&"
import script from "./SmsRejectIframe.vue?vue&type=script&lang=ts&"
export * from "./SmsRejectIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports